import { gql } from "@edreamsodigeo/frontend-api-client";

export const GET_MEMBERSHIP_ACCOUNT_PROPERTIES = gql`
  query MembershipAccountProperties($email: String) {
    membershipAccountProperties(email: $email) {
      isActive
      isActiveLogged
    }
  }
`;
